export default {
  "content": "<path d=\"M12.297.955H2.28C1.362.955.61 1.62.61 2.433v10.343h1.67V2.433h10.017V.955zm2.504 2.955H5.62c-.918 0-1.67.665-1.67 1.478V15.73c0 .813.752 1.478 1.67 1.478h9.182c.919 0 1.67-.665 1.67-1.478V5.388c0-.813-.751-1.478-1.67-1.478zm0 11.821H5.62V5.388h9.182V15.73z\" fill=\"#717684\"/>",
  "attrs": {
    "width": "17",
    "height": "18",
    "viewBox": "0 0 17 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};